<template>
    <div class="aup-box-select w-100">
        <div class="row m-0">
            <div class="col-12" v-for="(item, index) in items" :key="'last-half' + index">
                <BaseButton
                :filled="item === local_value ? true : false"
                :color="item === local_value ? 'orange' : 'black'"
                border="thin"
                class="w-100 my-2"
                @click="toggleItem(item)"
                >
                error:call:8
                </BaseButton>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BaseRadioSelect",
    props: {
        items: {
            type: Array,
        },
        value: {
            type: String,
        }
    },
    watch: {
        local_value(val) {
            this.$emit('input', val);
        }
    },
    computed: {
        isSelected: () => {

        },
    },
    data() {
        return {
            local_value: this.value
        };
    },
    methods: {
        toggleItem(item) {
            if ( this.local_value !== item ) {
                this.local_value = item;
            }
        }
    }
};
</script>
